module.exports = __webpack_public_path__ + "static/media/tags.8ff35323.svg";